import { EnvironmentProviders } from '@angular/core';
import { environment } from '@environments/environment';
import {
  provideRouter,
  withComponentInputBinding,
  withDebugTracing,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';
import { routes } from '../app.routes';

export function provideRouterWithConfig(): EnvironmentProviders {
  if (environment.debug.router) {
    return provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
        paramsInheritanceStrategy: 'always',
      }),
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
      withDebugTracing(),
    );
  }

  return provideRouter(
    routes,
    withRouterConfig({
      onSameUrlNavigation: 'reload',
      paramsInheritanceStrategy: 'always',
    }),
    withComponentInputBinding(),
    withInMemoryScrolling({
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  );
}
